export const LS_KEYS = {
  auth: '___als___',
  onboardingAuth: '___oals___',
  showNetworkErrorModal: '___snemls___',
  errorOTPCountdown: '___eocls___',
  generateOTPCountdown: '___gocls___',
  errorResendOTPCountdownWhatsapp: '___erocw___',
  errorResendOTPCountdownSMS: '___erocs___',
};

export function getItem(key: string) {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(key) || '';
  }
  return null;
}

export function setItem(key: string, data: string) {
  if (typeof window !== 'undefined') {
    return localStorage.setItem(key, data);
  }
  return null;
}

export function removeItem(key: string) {
  if (typeof window !== 'undefined') {
    return localStorage.removeItem(key);
  }
  return null;
}
